import * as React from "react";
const ModernCopyIcon = (props) => (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1284_14887)">
      <path
        d="M5.83333 5.49996V2.99996C5.83333 2.77895 5.92113 2.56698 6.07741 2.4107C6.23369 2.25442 6.44565 2.16663 6.66667 2.16663H16.6667C16.8877 2.16663 17.0996 2.25442 17.2559 2.4107C17.4122 2.56698 17.5 2.77895 17.5 2.99996V14.6666C17.5 14.8876 17.4122 15.0996 17.2559 15.2559C17.0996 15.4122 16.8877 15.5 16.6667 15.5H14.1667V18C14.1667 18.46 13.7917 18.8333 13.3275 18.8333H3.33917C3.22927 18.834 3.12033 18.8129 3.0186 18.7713C2.91687 18.7297 2.82436 18.6685 2.74638 18.591C2.6684 18.5136 2.60649 18.4215 2.56421 18.3201C2.52193 18.2186 2.50011 18.1099 2.5 18L2.5025 6.33329C2.5025 5.87329 2.8775 5.49996 3.34083 5.49996H5.83333ZM4.16833 7.16663L4.16667 17.1666H12.5V7.16663H4.16833ZM7.5 5.49996H14.1667V13.8333H15.8333V3.83329H7.5V5.49996ZM5.83333 9.66663H10.8333V11.3333H5.83333V9.66663ZM5.83333 13H10.8333V14.6666H5.83333V13Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1284_14887">
        <rect
          width={20}
          height={20}
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default ModernCopyIcon;
